import { render, staticRenderFns } from "./healthyProgrammeList.vue?vue&type=template&id=057d53a6&scoped=true&"
import script from "./healthyProgrammeList.vue?vue&type=script&lang=js&"
export * from "./healthyProgrammeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d53a6",
  null
  
)

export default component.exports